/* eslint-disable no-unused-expressions */
// @flow

import * as React from 'react';
import LazyLoad from 'react-lazyload';
import { withTranslation, Link } from '@i18n';
import { StyledWhatsappIcon } from '@components/ContactPageNew/styles';
import { useBreakpoint } from '@hooks';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Pagination, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
import {
  requestBlogArticles,
  resetBlogArticles
} from '@screens/Blog/redux/actions';
import { connect } from 'react-redux';
import ArticleCard from '@screens/Blog/Article/components/RelatedPostCard/articleCard';
import { calculateGridUnitSize } from '@lib/helpers';
import compose from 'lodash/fp/compose';
import type { Props } from './types';

import {
  StyledCover,
  StyledBannerBottomLeft,
  StyledConnectMessage,
  StyledContactButton,
  BannerRightManComponent,
  ConnectMessage,
  ConnectBlock,
  StyledBannerBlock,
  StyledMobileText,
  StyledCardsMaxWidth,
  StyledTrioWrapper,
  StyledHeading,
  StyledViewMoreButton,
  StyledWrapper,
  StyledSwiper
} from './styles';

SwiperCore.use([Navigation, Pagination]);


const HomeBannerBottom = ({
  t,
  requestBlogArticles,
  blogs
}: Props) => {
  const isMobile = useBreakpoint('mobile', 'tablet');
  const isTablet = useBreakpoint('tablet', 'desktop');

  /* eslint-disable no-nested-ternary */
  const onScreenCount = isMobile ? 2 : isTablet ? 2 : 4;
  React.useEffect(() => {
    requestBlogArticles({ pageNumber: 1 });
  }, []);

  const blogList = (blogs || []);


  return (
    <>
      <StyledTrioWrapper>
        <LazyLoad height="100%" offset={800} once>

          <StyledCover>
            <StyledBannerBlock>
              <StyledBannerBottomLeft>
                <ConnectBlock>
                  <ConnectMessage>{t('hero.OnlineConsultation')}</ConnectMessage>
                  <StyledMobileText>
                    {isMobile ? 'Yapita Health is here to make your surgery journey easier and stress-free.' : ''}
                  </StyledMobileText>
                  <StyledContactButton
                    full
                    id="WhatsappContactID"
                    href="https://api.whatsapp.com/send?phone=919599818171&text=Hello%20Yapita%20Health.%20I%20need%20medical%20assistance%20for:"
                    target="_blank"
                    finderForm
                  >
                    <StyledWhatsappIcon />
                    <StyledConnectMessage>{t('hero.QuickConnect')}</StyledConnectMessage>
                  </StyledContactButton>
                </ConnectBlock>
              </StyledBannerBottomLeft>
              {isMobile ? <></>
                : (
                  <BannerRightManComponent>
                    <img src="../../../static/images/home/BannerRight.webp" alt="Healthcare Expert - Yapita Health" />
                  </BannerRightManComponent>
                )}

            </StyledBannerBlock>
          </StyledCover>
        </LazyLoad>
      </StyledTrioWrapper>

      <StyledHeading>
        {t('TopRead')}
      </StyledHeading>
      <StyledCardsMaxWidth>
        <StyledSwiper>
          <Swiper
            slidesPerView={isMobile ? 2 : 4}
            spaceBetween={5}
            loop={false}
            pagination={isMobile}
            navigation={false}
          >
            {(blogList || []).slice(0, 4).map(object => (
              <SwiperSlide key={object.id}>
                <ArticleCard
                  key={object.id}
                  size={{
                    mobile:
                     1
                    / calculateGridUnitSize((blogList || [])
                      .slice(0, 8).length, onScreenCount)
                  }}
                  article={object}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </StyledSwiper>

        <StyledWrapper>
          <Link passHref href="/blog">
            <StyledViewMoreButton>{t('ViewMore')}</StyledViewMoreButton>
          </Link>
        </StyledWrapper>
      </StyledCardsMaxWidth>
    </>
  );
};

const mapStateToProps = (state: GlobalState) => ({
  blogs: state.blogData.data
});

export default compose(
  withTranslation('Home'),
  connect(
    mapStateToProps,
    {
      requestBlogArticles,
      resetBlogArticles
    }
  ),
)(HomeBannerBottom);
